import { createSlice } from "@reduxjs/toolkit";
import {
  getSpecificSettingThunk,
  getAllLanguagesThunk,
  getAllSafetyQuestionsThunk,
  getCountryListThunk
} from "./settingsActions";

export interface ISettingsState {
  loading: boolean;
  specificSetting: object | null;
  languagesLoading: boolean;
  languages: Array<any>;
  safetyQuestions: Array<any>;
  safetyQuestionsLoading: boolean;
  countryListLoading: boolean;
  countries: Array<any>;
}

const initialState: ISettingsState = {
  loading: false,
  specificSetting: null,
  languagesLoading: false,
  languages: [],
  safetyQuestions: [],
  safetyQuestionsLoading: false,
  countryListLoading: false,
  countries: []
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    resetSpecificSetting: (state) => {
      state.specificSetting = null;
    }
  },
  extraReducers: (builder) => {
    // Get User Settings Action Cases
    builder.addCase(getSpecificSettingThunk.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(getSpecificSettingThunk.fulfilled, (state, action) => {
      state.specificSetting = action.payload;
      state.loading = false;
    });

    builder.addCase(getSpecificSettingThunk.rejected, (state) => {
      state.loading = false;
    });

    // Get All Languages Action Cases
    builder.addCase(getAllLanguagesThunk.pending, (state) => {
      state.languagesLoading = true;
    });

    builder.addCase(getAllLanguagesThunk.fulfilled, (state, action) => {
      state.languages = action.payload;
      state.languagesLoading = false;
    });

    builder.addCase(getAllLanguagesThunk.rejected, (state) => {
      state.languagesLoading = false;
    });

    // Get All Safety Questions Action Cases
    builder.addCase(getAllSafetyQuestionsThunk.pending, (state) => {
      state.safetyQuestionsLoading = true;
    });

    builder.addCase(getAllSafetyQuestionsThunk.fulfilled, (state, action) => {
      state.safetyQuestions = action.payload;
      state.safetyQuestionsLoading = false;
    });

    builder.addCase(getAllSafetyQuestionsThunk.rejected, (state) => {
      state.safetyQuestionsLoading = false;
    });

    // Get All CountryList Action Cases
    builder.addCase(getCountryListThunk.pending, (state) => {
      state.countryListLoading = true;
    });

    builder.addCase(getCountryListThunk.fulfilled, (state, action) => {
      state.countries = action.payload;
      state.countryListLoading = false;
    });

    builder.addCase(getCountryListThunk.rejected, (state) => {
      state.countryListLoading = false;
    });
  }
});

export const { resetSpecificSetting } = settingsSlice.actions;

export * from "./settingsActions";
export default settingsSlice.reducer;
